import React from 'react'
import { Grid, GridItem } from '@deal/components'
import styles from './styles.css'

const JetDisclaimer: React.SFC = () => {
  return (
    <div className={styles.wrapper}>
      <Grid>
        <GridItem col={2}>
          Curated.com, Inc. d/b/a Curated.com acts on behalf of its clients and serves as their
          agent. It does not own or operate aircraft; all charter flights are operated by FAA
          Certified Part 135 or Part 121 air carriers.
        </GridItem>
      </Grid>
    </div>
  )
}

export default JetDisclaimer
